import {RedirectRoute, Route} from "../classes/RouteTypes";

export default [
    new RedirectRoute({path: '/', name: 'index', redirect: {name: 'login'}}),

    new Route({path: '/forgotten-password', name: 'forgottenPassword',
        label: 'navigation.forgottenPassword', hidden: true,
        component: () => import('../pages/guest/forgottenPassword/Frame')
    }),

    new Route({path: '/forgotten-password/notification', name: 'forgottenPassword.notification',
        label: 'navigation.forgottenPassword.notification', hidden: true,
        component: () => import('../pages/guest/forgottenPassword/Notification')
    }),

    new Route({path: '/change-password/:token', hidden: true,
        component: () => import('../pages/guest/forgottenPassword/ChangeRequest')
    }),
];
